import { useState, useEffect, useRef } from 'react';
import {
  DateBlock,
  DateSettingsBlock,
  DateSettingsDeleteIcon,
  DateSettingsIcon,
  FilterItem,
  FilterList,
  FilterMenuContainer,
  Plus,
  SearchButton,
  SearchInput,
  SelectInput,
} from './FilterMenu.styled';
import DateSettings from '../DateSettings/DateSettings';
import {
  selectQaChatsProjects,
  selectUserType,
  selectQaGroups,
} from '../../../redux/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const FilterMenu = ({
  selectedProject,
  selectedGroup,
  handleProjectChange,
  handleGroupChange,
  handleColorChange,
  selectedColor,
  selectedStatus,
  handleStatusChange,
  setIsOpenFilter,
  openModal,
  DeleteDate,
  closeModal,
  setIsAfterDate,
  setIsBeforeDate,
  clickModal,
  isSettingsOpen,
  searchInputId,
  searchId,
  searchThreadId,
  searchInputUser,
  searchUser,
  searchThreadInputId,
  searchInputChecked,
  searchChecked,
  afterDate,
  beforeDate,
}) => {
  const [openFilter, setOpenFilter] = useState(null);
  const [agent, setAgent] = useState('');
  const menuRef = useRef(null);
  const location = useLocation();
  const proj = useSelector(selectQaChatsProjects);
  const utype = useSelector(selectUserType);
  const groups = useSelector(selectQaGroups);

  // Проверяем localStorage при монтировании компонента
  useEffect(() => {
    const savedGroup = localStorage.getItem('selectedQaGroup');
    if (savedGroup && handleGroupChange) {
      handleGroupChange({ target: { value: savedGroup } });
      // Очищаем сохраненное значение после использования
      localStorage.removeItem('selectedQaGroup');
    }
  }, [handleGroupChange]);
  
  const handleFilterToggle = id => {
    // Логика взаимного исключения между группой и датой
    if (id === 'group' && selectedGroup) {
      // Если выбран фильтр группы и уже есть выбранная группа, блокируем выбор даты
      setOpenFilter(prevId => (prevId === id ? null : id));
    } else if (id === 'date' && selectedGroup) {
      // Если пытаемся выбрать дату, но уже выбрана группа, показываем предупреждение
      alert('Сначала очистите фильтр группы, чтобы выбрать дату');
      return;
    } else if (id === 'group' && (afterDate || beforeDate)) {
      // Если пытаемся выбрать группу, но уже выбрана дата, показываем предупреждение
      alert('Сначала очистите фильтр даты, чтобы выбрать группу');
      return;
    } else {
      setOpenFilter(prevId => (prevId === id ? null : id));
    }
    console.log(openFilter);
  };


  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpenFilter(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  return (
    <FilterMenuContainer ref={menuRef}>
      <FilterList>
        {location.pathname === '/PaymentBot' ? (
          <FilterItem onClick={() => handleFilterToggle('date')}>
            Дата
            <Plus />
            {openFilter === 'date' && (
              <DateBlock onClick={e => e.stopPropagation()}>
                <DateSettingsBlock>
                  <DateSettingsIcon
                    onClick={openModal}
                    title={'Выбрать дату'}
                  />
                  <DateSettingsDeleteIcon
                    onClick={DeleteDate}
                    title={'Удалить дату'}
                  />
                  {isSettingsOpen && (
                    <DateSettings
                      closeModal={closeModal}
                      title={'Выбрать дату'}
                      setIsAfterDate={setIsAfterDate}
                      setIsBeforeDate={setIsBeforeDate}
                      clickModal={clickModal}
                    />
                  )}
                </DateSettingsBlock>
              </DateBlock>
            )}
          </FilterItem>
        ) : (
          <>
            <FilterItem onClick={() => handleFilterToggle('project')}>
              Проект
              <Plus />
              {openFilter === 'project' && (
                <SelectInput
                  title={'Выбрать проект'}
                  value={selectedProject}
                  onChange={handleProjectChange}
                  onClick={e => e.stopPropagation()}
                >
                  <option value="">Все</option>
                  {proj?.map(item => (
                    <option key={item?.pk} value={item?.pk}>
                      {item?.title}
                    </option>
                  ))}
                </SelectInput>
              )}
            </FilterItem>
            {/* Фильтр группы только для пользователей с utype !== "agent" */}
            {utype !== 'agent' && (
              <FilterItem 
                onClick={() => handleFilterToggle('group')}
                style={{
                  opacity: (afterDate || beforeDate) ? 0.5 : 1,
                  cursor: (afterDate || beforeDate) ? 'not-allowed' : 'pointer',
                  pointerEvents: (afterDate || beforeDate) ? 'none' : 'auto'
                }}
                title={(afterDate || beforeDate) ? 'Сначала очистите фильтр даты' : 'Выбрать группу'}
              >
                Группа
                <Plus />
                {openFilter === 'group' && !(afterDate || beforeDate) && (
                  <SelectInput
                    title={'Выбрать группу'}
                    value={selectedGroup}
                    onChange={handleGroupChange}
                    onClick={e => e.stopPropagation()}
                  >
                    <option value="">Все группы</option>
                    {groups?.map(group => (
                      <option key={group.id} value={group.id}>
                        {group.name}
                      </option>
                    ))}
                  </SelectInput>
                )}
              </FilterItem>
            )}
            <FilterItem onClick={() => handleFilterToggle('color')}>
              Цвет чата
              <Plus />
              {openFilter === 'color' && (
                <SelectInput
                  title={'Выбрать цвет'}
                  value={selectedColor}
                  onChange={handleColorChange}
                  onClick={e => e.stopPropagation()}
                >
                  <option value="">Все</option>
                  <option value="green">Зеленый</option>
                  <option value="yellow">Желтый</option>
                  <option value="red">Красный</option>
                </SelectInput>
              )}
            </FilterItem>
            <FilterItem onClick={() => handleFilterToggle('userType')}>
              Тип юзера
              <Plus />
              {openFilter === 'userType' && (
                <SelectInput
                  title={'Выбрать вид'}
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  onClick={e => e.stopPropagation()}
                >
                  <option value="">Все</option>
                  <option value="vip">Вип</option>
                  <option value="other">Другие</option>
                </SelectInput>
              )}
            </FilterItem>
            <FilterItem 
              onClick={() => handleFilterToggle('date')}
              style={{
                opacity: selectedGroup ? 0.5 : 1,
                cursor: selectedGroup ? 'not-allowed' : 'pointer',
                pointerEvents: selectedGroup ? 'none' : 'auto'
              }}
              title={selectedGroup ? 'Сначала очистите фильтр группы' : 'Выбрать дату'}
            >
              Дата
              <Plus />
              {openFilter === 'date' && !selectedGroup && (
                <DateBlock onClick={e => e.stopPropagation()}>
                  <DateSettingsBlock>
                    <DateSettingsIcon
                      onClick={openModal}
                      title={'Выбрать дату'}
                    />
                    <DateSettingsDeleteIcon
                      onClick={DeleteDate}
                      title={'Удалить дату'}
                    />
                    {isSettingsOpen && (
                      <DateSettings
                        closeModal={closeModal}
                        title={'Выбрать дату'}
                        setIsAfterDate={setIsAfterDate}
                        setIsBeforeDate={setIsBeforeDate}
                        clickModal={clickModal}
                      />
                    )}
                  </DateSettingsBlock>
                </DateBlock>
              )}
            </FilterItem>
            {/* Скрываем фильтр по агенту на странице personal-chat-stat */}
            {location.pathname !== '/personal-chat-stat' && (
              <FilterItem onClick={() => handleFilterToggle('agent')}>
                Агент
                <Plus />
                {openFilter === 'agent' && (
                  <>
                    <SearchInput
                      placeholder="Введите имя агента..."
                      onChange={e => setAgent(e.target.value)}
                      onClick={e => e.stopPropagation()}
                    />
                    <SearchButton onClick={() => searchInputUser(agent)}>
                      +
                    </SearchButton>
                  </>
                )}
              </FilterItem>
            )}
            {/* <FilterItem onClick={() => handleFilterToggle('id')}>
              Chat ID
              <Plus />
              {openFilter === 'id' && (
                <SearchInput
                  placeholder="Введите айди чата..."
                  onChange={searchInputId}
                  value={searchId}
                  onClick={e => e.stopPropagation()}
                />
              )}
            </FilterItem> */}
            <FilterItem onClick={() => handleFilterToggle('threadId')}>
              Чат ID
              <Plus />
              {openFilter === 'threadId' && (
                <SearchInput
                  placeholder="Введите айди чата..."
                  onChange={searchThreadInputId}
                  value={searchThreadId}
                  onClick={e => e.stopPropagation()}
                />
              )}
            </FilterItem>
            <FilterItem onClick={() => handleFilterToggle('checked')}>
              Проверка
              <Plus />
              {openFilter === 'checked' && (
                <SelectInput
                  title={'Выбрать вид'}
                  value={searchChecked}
                  onChange={searchInputChecked}
                  onClick={e => e.stopPropagation()}
                >
                  <option value="">Проверка</option>
                  <option value="true">Положительная</option>
                  <option value="false">Отрицательная</option>
                </SelectInput>
              )}
            </FilterItem>
          </>
        )}
      </FilterList>
    </FilterMenuContainer>
  );
};

export default FilterMenu;
